import { LitElement, html, css } from 'lit-element';

const SpeechRecognition = window.webkitSpeechRecognition;

/**
 * Chat form
 *
 * @csspart container
 * @csspart icon-send
 *
 * @cssprop [--chat-input-background=#f3f7f9] - input background color
 * @cssprop [--chat-input-color=#000000] - input color
 * @cssprop [--chat-input-font-size=1rem] - input font size
 * @cssprop [--chat-bot-primary-color=#006699] - input font size
 */
export class ChatInput extends LitElement {
  // SpeechRecognition = window.webkitSpeechRecognition;
  // recognition = new window.webkitSpeechRecognition();

  static get properties() {
    return {
      accessibleDescription: {
        type: String,
      },
      icon: {
        type: String,
      },
      micro: {
        type: String,
      },
      value: {
        type: String,
      },
    };
  }

  constructor() {
    super();
    this.value = '';
    this._formElementId = this.constructor.uniqueID();
    this.icon = new URL('../assets/icon-send.svg', import.meta.url).pathname;
    this.micro =
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32.33 46.1'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23dadada;%7D.cls-2%7Bfill:%2386bc25;%7D.cls-3%7Bfill:%23575756;%7D%3C/style%3E%3C/defs%3E%3Cg id='Capa_2' data-name='Capa 2'%3E%3Cg id='Capa_6' data-name='Capa 6'%3E%3Crect class='cls-1' x='9.14' y='1' width='13.97' height='30.13' rx='6.99'/%3E%3Cline class='cls-2' x1='16.13' y1='37.09' x2='16.13' y2='45.15'/%3E%3Crect class='cls-3' x='15.13' y='37.09' width='2' height='8.06'/%3E%3Cline class='cls-2' x1='5.74' y1='45.1' x2='26.52' y2='45.1'/%3E%3Cpath class='cls-3' d='M26.52,46.1H5.74a1,1,0,0,1,0-2H26.52a1,1,0,1,1,0,2Z'/%3E%3Crect class='cls-3' x='0.38' y='17.14' width='8.52' height='2'/%3E%3Crect class='cls-3' x='23.01' y='17.14' width='8.86' height='2'/%3E%3Cpath class='cls-3' d='M19.33,38.36H13a13,13,0,0,1-13-13V15.89a1,1,0,0,1,2,0v9.47a11,11,0,0,0,11,11h6.33a11,11,0,0,0,11-11V15.89a1,1,0,0,1,2,0v9.47A13,13,0,0,1,19.33,38.36Z'/%3E%3Cpath class='cls-2' d='M14.12,11.64H9.64a.75.75,0,0,1,0-1.5h4.48a.75.75,0,0,1,0,1.5Z'/%3E%3Cpath class='cls-2' d='M22.61,11.64H18.1a.75.75,0,0,1,0-1.5h4.51a.75.75,0,0,1,0,1.5Z'/%3E%3Cpath class='cls-2' d='M14.12,15.09H9.64a.75.75,0,0,1,0-1.5h4.48a.75.75,0,1,1,0,1.5Z'/%3E%3Cpath class='cls-2' d='M22.61,15.09H18.1a.75.75,0,0,1,0-1.5h4.51a.75.75,0,0,1,0,1.5Z'/%3E%3Cpath class='cls-2' d='M14.12,18.54H9.64a.75.75,0,0,1,0-1.5h4.48a.75.75,0,0,1,0,1.5Z'/%3E%3Cpath class='cls-2' d='M22.61,18.54H18.1a.75.75,0,0,1,0-1.5h4.51a.75.75,0,0,1,0,1.5Z'/%3E%3Cpath class='cls-2' d='M14.12,22H9.64a.75.75,0,0,1,0-1.5h4.48a.75.75,0,1,1,0,1.5Z'/%3E%3Cpath class='cls-2' d='M22.61,22H18.1a.75.75,0,0,1,0-1.5h4.51a.75.75,0,0,1,0,1.5Z'/%3E%3Cpath class='cls-3' d='M16.13,32.13a8,8,0,0,1-8-8V8a8,8,0,0,1,16,0V24.14A8,8,0,0,1,16.13,32.13ZM16.13,2a6,6,0,0,0-6,6V24.14a6,6,0,0,0,12,0V8A6,6,0,0,0,16.13,2Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
    this.accessibleDescription = 'Enviar mensaje';
    this.speechActive = false;
    this.browserSupportsSpeechRecognition = !!SpeechRecognition;
    if (this.browserSupportsSpeechRecognition) {
    this.recognition = new SpeechRecognition();
  }
  }

  /**
   * Random unique ID for input
   * @param  {Number} length Length of random ID
   * @return {String}        Unique ID
   */
  static uniqueID(length = 10) {
    return `_${Math.random()
      .toString(36)
      .substr(2, length)}`;
  }

  render() {
    return html`
      <form part="container">
        <input
          id="${this._formElementId}"
          .value="${this.value}"
          @input="${this._onInput}"
          @keypress="${this._onKeyPress}"
          placeholder="Escribe aquí"
          aria-labelledby="description${this._formElementId}"
        ></input>
        <span style="display: none;" id="description${this._formElementId}">
          ${this.accessibleDescription}
        </span>
          <button type="button" @click="${this.submit}">
            <img alt="Enviar" src="${this.icon}" part="icon-send" />
          </button>
          ${
            this.browserSupportsSpeechRecognition
              ? html`
          <button part="micro" type="button" @click="${this.runSpeechRecognition}">
            <img alt="Enviar" src="${this.micro}" part="icon-micro" />
          </button>
                `
              : html``
          }

      </form>
    `;
  }

  static get styles() {
    return css`
      [part='container'] {
        position: relative;
        height: 100%;
      }

      input {
        width: 100%;
        outline: none;
        background: var(--chat-input-background, #f3f7f9);
        color: var(--chat-input-color, #000000);
        resize: none;
        box-sizing: border-box;
        border: none;
        height: 100%;
        line-height: 2rem;
        padding: 0;
        padding-left: 0.5rem;
        padding-right: 3rem;
        font-size: var(--chat-input-font-size, 0.8rem);
        overflow: auto;
      }

      button {
        position: absolute;
        height: 100%;
        top: auto;
        outline: none;
        right: 10px;
        background: none;
        border: none;
        cursor: pointer;
      }

      button img {
        width: 1rem;
      }

      [part='micro'] {
        position: absolute;
        height: 100%;
        top: auto;
        outline: none;
        right: 0.3rem;
        background: none;
        border: none;
        cursor: pointer;
        display: none;
        z-index: 103;
      }
      [part='micro'] :hover {
        box-shadow: 0px;
      }

      [part='micro']:active {
        opacity: 1;
        box-shadow: 0px;
      }

      @media only screen and (max-width: 768px) {
        [part='micro'] {
          display: inline;
        }
        input {
          padding-right: 6rem;
        }
        button {
          right: 2rem;
        }
      }
    `;
  }

  _onInput(e) {
    this.value = e.target.value.trim();
  }

  _onKeyPress(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      if (this.value) {
        this.submit();
      }
    }
  }

  submit(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    /**
     * Fired when send button is clicked
     * @event alc-chat-form-send
     * @param {String} text Text sent from the field
     */
    this.dispatchEvent(
      new CustomEvent('submit', {
        composed: true,
        bubbles: true,
        detail: {
          text: this.value,
        },
      }),
    );
    this.value = '';
  }

  runSpeechRecognition() {
    const self = this;

    if (!self.browserSupportsSpeechRecognition) {
      return;
    }

    if (self.active) {
      self.active = false;
      self.recognition.stop();
      return;
    }

    self.recognition.onspeechend = () => {
      self.active = false;
      self.recognition.stop();
    };
    self.recognition.onresult = event => {
      const { transcript } = event.results[0][0];
      // let confidence = event.results[0][0].confidence;
      self.value = transcript;
      if (self.value) {
        self.submit();
      }
      this.dispatchEvent(
        new CustomEvent('microAction', {
          composed: true,
          bubbles: true,
          detail: { on: false },
        }),
      );
    };
    self.recognition.onend = () => {
      this.dispatchEvent(
        new CustomEvent('microAction', {
          composed: true,
          bubbles: true,
          detail: { on: false },
        }),
      );
    };
    // start recognition
    this.dispatchEvent(
      new CustomEvent('microAction', {
        composed: true,
        bubbles: true,
        detail: { on: true },
      }),
    );
    self.recognition.start();
    self.active = true;
  }
}
